/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SynthesizeSessionAudioRequest } from '../../models/synthesize-session-audio-request';
import { SynthesizeSessionAudioResult } from '../../models/synthesize-session-audio-result';

export interface ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Params {
  agentId: string;
  sessionId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: SynthesizeSessionAudioRequest
}

export function apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost(http: HttpClient, rootUrl: string, params: ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Params, context?: HttpContext): Observable<StrictHttpResponse<SynthesizeSessionAudioResult>> {
  const rb = new RequestBuilder(rootUrl, apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost.PATH, 'post');
  if (params) {
    rb.path('agentId', params.agentId, {});
    rb.path('sessionId', params.sessionId, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SynthesizeSessionAudioResult>;
    })
  );
}

apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost.PATH = '/api/Agents/{agentId}/sessions/{sessionId}/audio/synthesize';
